var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('projects-doing',{staticClass:"my-2"}),_c('projects-done',{staticClass:"my-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }